module.exports = __webpack_public_path__ + "img/Planning_icon.45fbe607.png";